import React, { useState, useMemo, useCallback, useEffect } from "react";
import { darken, lighten } from "polished";
import createColumnDefs from "./columnDefs.js";
import localStorage from "local-storage";
import SearchIcon from "@mui/icons-material/Search";

import {
  Grid,
  Typography,
  Pagination,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import localeTextTr from "../../../locale.tr.js";
import Swal from "sweetalert2";
import { cleanupLocalStorage } from "../../../utils/localStorage/cleanupLocalStorage.js";

import gridSideBar from "../../../components/GridSideBar/gridSideBar.js";
import { createTurkishFilterParams } from "../../../utils/agGridTextFilterTr/agGridFilterUtils.js";
import { getNotes } from "../../../api/notesApis/getNotes.js";
import { deleteNote } from "../../../api/notesApis/deleteNote.js";
import { getTaxPayerListForNotification } from "../../../api/taxPayer/getTaxPayerListForNotification/index.js";
import UserOperationsMenu from "./UserOperationsMenu.js";
import { getSubUsers } from "../../../api/user/getSubUsers/index.js";
import { getTaxpayerListForCustomerCards } from "../../../api/customerCards/getTaxPayerListForCustomerCards.js";

export default function MyUsersPage() {
  const [status, setStatus] = useState(false);

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchedValue, setSearchedValue] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [taxpayerList, setTaxpayerList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    search();
  }, []);
  const search = async () => {
    setLoading(true);
    await getTaxpayerListForCustomerCards().then(async (resp) => {
      setTaxpayerList(resp?.data?.data || []);
    });
    await getSubUsers()
      .then(async (resp) => {
        setRowData(resp.data || []);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        Swal.fire({
          text: err.response.data.message || "Notlar alınırken hata oluştu.",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            container: ".swal-overlay",
          },
        });
      });
  };
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal açık/kapalı

  // Modal'ı aç
  const openModal = (note) => {
    setIsModalOpen(true);
  };

  // Modal'ı kapat
  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Silme işlemi
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Silmek istediğinize emin misiniz?",
      text: "Bu işlem geri alınamaz!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Evet, sil!",
      cancelButtonText: "Hayır, iptal et",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    await deleteNote(id)
      .then(async (resp) => {
        await Swal.fire({
          title: "Başarıyla silindi!",
          text: "Kayıt başarıyla kaldırıldı.",
          icon: "success",
        });
        search();
      })
      .catch(async (err) => {
        await Swal.fire({
          title: "Hata!",
          text: "Silme işlemi sırasında bir hata oluştu.",
          icon: "error",
        });
      });
  };

  const [columnDefs, setColumnDefs] = useState(createColumnDefs());

  const detailCellRendererParams = useMemo(() => {
    return {
      detailGridOptions: {
        columnDefs: [
          {
            field: "title",
            headerName: "Mükellef Adı",
            filter: "agTextColumnFilter",
          },
          { field: "vkn", headerName: "vkn", filter: "agTextColumnFilter" },
          {
            field: "tckn",
            headerName: "Tc Kimlik No",
            filter: "agTextColumnFilter",
          },
          { field: "ledgerType", headerName: "Defter Tipi", filter: true },
        ],
        enableRangeSelection: true,
        defaultColDef: {
          flex: 0.5,
          resizable: true,
          sortable: true,
          floatingFilter: true,
          suppressMenu: false,
        },
      },
      getDetailRowData: (params) => {
        const taxpayerIds = params.data.taxpayerIds || [];
        const matchedTaxpayers = taxpayerList.filter((tp) =>
          taxpayerIds.includes(tp.id)
        );
        console.log(matchedTaxpayers, "matchedTaxpayers");
        params.successCallback(matchedTaxpayers);
      },
    };
  }, [taxpayerList]);
  const defaultColDef = useMemo(
    () => ({
      // minWidth: 100,
      // flex: 1,
      filter: true,
      sortable: true,
      // resizable: true,
      floatingFilter: true,
      filterParams: createTurkishFilterParams(),
    }),
    []
  );
  const [selectedUser, setSelectedUser] = useState(null);
  // const onFirstDataRendered = (params) => {};
  const onSelectionChanged = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedUser(...selectedData);
  };
  const onGridReady = useCallback(
    (params) => {
      // setGridApi(params.api); // gridApi'yi burada ayarlayın
    },
    [rowData]
  );
  // `workStatusOptions`'ı sıralama için kullanacağımız bir map oluşturuyoruz

  return (
    <Grid container>
      <Grid
        item
        sx={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          flexDirection: "column",
          pr: "12px",
        }}
      >
        <Grid
          item
          md={12}
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid
            className="grid-area"
            sx={{
              mb: 1,
            }}
          >
            <Grid
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 1,
              }}
            >
              <Grid>
                <UserOperationsMenu
                  selectedUser={selectedUser}
                  taxpayerList={taxpayerList}
                  search={search}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            className="ag-theme-quartz"
            style={{
              flex: 1,
              minHeight: "70vh",
              maxHeight: "70vh",
              width: "100%",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
              borderRadius: "10px", // İstediğiniz değeri buraya ekleyin
              overflow: "hidden", // Border-radius'in düzgün görünmesi için
            }}
          >
            <AgGridReact
              localeText={localeTextTr}
              onSelectionChanged={onSelectionChanged}
              rowSelection="single"
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              loading={loading}
              enableRangeSelection={true}
              sideBar={gridSideBar}
              getRowStyle={(params) => {
                if (params.data.is_deleted === true) {
                  return { background: lighten(0.4, "red") };
                }
              }}
              copyHeadersToClipboard={false}
              defaultColDef={defaultColDef}
              masterDetail={true}
              detailCellRendererParams={detailCellRendererParams}
              detailRowAutoHeight={true}
              isRowMaster={(data) => {
                return data.taxpayerIds && data.taxpayerIds.length > 0;
              }}
              suppressRowDeselection={false}
              rowMultiSelectWithClick={true}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              justifyContent: "space-between",
              display: rowData?.length === 0 ? "none" : "flex",

              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: rowData?.length === 0 ? "none" : "flex",
                margin: "2% 0 2% 0",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  position: "absolute",
                  right: "3%",
                  display: !loading ? "block" : "none",
                }}
              >
                Toplam Kayıt : {totalCount}{" "}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
